import { useState } from 'react';

const useInlineEdit = () => {
  const [editingId, setEditingId] = useState<string | null>(null);
  const [editValue, setEditValue] = useState('');
  const start = (id: string, current: string) => { setEditingId(id); setEditValue(current); };
  const cancel = () => { setEditingId(null); setEditValue(''); };
  return { editingId, editValue, setEditValue, start, cancel };
};

export default useInlineEdit;
